import { Breakpoint } from 'api/contentful/contentTypes.cloverdotcom';

export const shouldDisplayLinkAsCustomIconForBreakpoint = (
  customIconAppearsIn?: ReadonlyArray<Breakpoint>,
  isMobile?: boolean,
  isTablet?: boolean,
  isDesktopOrLarger?: boolean,
) => {
  if (!customIconAppearsIn) return false;

  return (
    (isMobile && customIconAppearsIn.includes(Breakpoint.MOBILE)) ||
    (isTablet && customIconAppearsIn.includes(Breakpoint.TABLET)) ||
    (isDesktopOrLarger && customIconAppearsIn.includes(Breakpoint.DESKTOP))
  );
};
